import type { IconProps } from './types';

export const ArrowNarrowUpIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path d="M12 23.25V2.15625" stroke={color} strokeWidth="1.5" />
      <path d="M19.5 9.65625L12 2.15625L4.5 9.65625" stroke={color} strokeWidth="1.5" />
    </svg>
  );
};
